import React, { useEffect, useState, useRef } from "react";
import './Botoesmobile.css';
import { useMediaQuery } from 'react-responsive';
import { sendCommandFlex35 } from "../../../API/AcionamentoFlex35";
import { getLuzesStatusFlex35, statusDasLuzesFlex35 } from "../../../API/FeedBackLuzes";

function BotoesMobile() {
  
  const isMobile = useMediaQuery({ maxWidth: 767 }); // Ajuste o valor conforme necessário

  const groupRefs = useRef({
    grupo01: React.createRef(),
    grupo02: React.createRef(),
    grupo03: React.createRef(),
    grupo04: React.createRef(),
    grupo06: React.createRef(),
    grupo26: React.createRef(),
    grupo28: React.createRef(),
  });

  const [imageStates, setImageStates] = useState({
    grupo01: false,
    grupo02: false,
    grupo03: false,
    grupo04: false,
    grupo06: false,
    grupo26: false,
    grupo28: false,
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      await getLuzesStatusFlex35();
      updateLightGroup();
      setLoading(false);
      console.log("Status das luzes:", statusDasLuzesFlex35);
    };
    
    fetchData();

    const intervalId = setInterval(fetchData, 8300);
  
    return () => clearInterval(intervalId);
  }, []);

  const updateLightGroup = () => {
    setImageStates({
      grupo01: statusDasLuzesFlex35.includes("1A10") && !statusDasLuzesFlex35.includes("1A00"),
      grupo02: statusDasLuzesFlex35.includes("1B10") && !statusDasLuzesFlex35.includes("1B00"),
      grupo03: statusDasLuzesFlex35.includes("1C10") && !statusDasLuzesFlex35.includes("1C00"),
      grupo04: statusDasLuzesFlex35.includes("1D10") && !statusDasLuzesFlex35.includes("1D00"),
      grupo06: statusDasLuzesFlex35.includes("1F10") && !statusDasLuzesFlex35.includes("1F00"),
      grupo26: statusDasLuzesFlex35.includes("1Z10") && !statusDasLuzesFlex35.includes("1Z00"),
      grupo28: statusDasLuzesFlex35.includes("1b10") && !statusDasLuzesFlex35.includes("1b00"),
    });
  };

  const handleToggleLightGroup = (groupId, newImageState) => {
    setImageStates(prevState => ({ ...prevState, [groupId]: newImageState }));
  };

  
  if (!isMobile) {
    return null; // Não renderiza o componente em telas maiores
  }

  if (loading) {
    return null;
  }

  return (

    <div id="BotoesMobile">
        <h2 id='Title-botoes-Mobile'>Térreo</h2>
        {/* Botões para clicar em cima da legenda */}
        <div className="campoBotoesAcionamento-mobile">
          <div
            ref={groupRefs.current.grupo01}
            className="campoGroup-clickable-element-mobile"
            style={{ top: '66.4%', left: '80%' }}
            onClick={() => {
              handleToggleLightGroup('grupo01', !imageStates.grupo01);
              sendCommandFlex35('Postes', imageStates.grupo01 ? '1A00' : '1A10');
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo01 ? 'Highlighted' : ''}`}>1</p>
            <p className="textBar">Postes</p>
          </div>
          <div
            ref={groupRefs.current.grupo02}
            className="campoGroup-clickable-element-mobile"
            style={{ top: '70.5%', left: '80%' }}
            onClick={() => {
              handleToggleLightGroup('grupo02', !imageStates.grupo02);
              sendCommandFlex35('Degraus / Portíco', imageStates.grupo02 ? '1B00' : '1B10');
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo02 ? 'Highlighted' : ''}`}>2</p>
            <p className="textBar">Degraus / Portíco</p>
          </div>
          <div
            ref={groupRefs.current.grupo03}
            className="campoGroup-clickable-element-mobile"
            style={{ top: '74.7%', left: '80%' }}
            onClick={() => {
              handleToggleLightGroup('grupo03', !imageStates.grupo03);
              sendCommandFlex35('Espetos', imageStates.grupo03 ? '1C00' : '1C10');
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo03 ? 'Highlighted' : ''}`}>3</p>
            <p className="textBar">Espetos</p>          
          </div>
          <div
            ref={groupRefs.current.grupo04}
            className="campoGroup-clickable-element-mobile"
            style={{ top: '78.9%', left: '80%' }}
            onClick={() => {
              handleToggleLightGroup('grupo04', !imageStates.grupo04);
              sendCommandFlex35('Arandelas Veículos', imageStates.grupo04 ? '1D00' : '1D10');
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo04 ? 'Highlighted' : ''}`}>4</p>
            <p className="textBar">Arandelas Veículos</p>          
          </div>
          <div
            ref={groupRefs.current.grupo06}
            className="campoGroup-clickable-element-mobile"
            style={{ top: '83%', left: '80%' }}
            onClick={() => {
              handleToggleLightGroup('grupo06', !imageStates.grupo06);
              sendCommandFlex35('Tomadas Gourmet', imageStates.grupo06 ? '1F00' : '1F10');
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo06 ? 'Highlighted' : ''}`}>6</p>
            <p className="textBar">Tomadas gourmet</p>          
          </div>
          <div
            ref={groupRefs.current.grupo26}
            className="campoGroup-clickable-element-mobile"
            style={{ top: '87.2%', left: '80%' }}
            onClick={() => {
              handleToggleLightGroup('grupo26', !imageStates.grupo26);
              sendCommandFlex35('Circulação Térreo', imageStates.grupo26 ? '1Z00' : '1Z10');
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo26 ? 'Highlighted' : ''}`}>26</p>
            <p className="textBar">Circulação Térreo</p>          
          </div>
          <div
            ref={groupRefs.current.grupo28}
            className="campoGroup-clickable-element-mobile"
            style={{ top: '91.2%', left: '80%' }}
            onClick={() => {
              handleToggleLightGroup('grupo28', !imageStates.grupo28);
              sendCommandFlex35('Rota de Fuga', imageStates.grupo28 ? '1\\00' : ' 1\\10');
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo28 ? 'Highlighted' : ''}`}>28</p>
            <p className="textBar">Rota de Fuga</p>              
          </div>
        </div>
    </div>
  );
}

export default BotoesMobile;